import React from 'react';
import { Typography } from '@forgeglobal/design-framework';
import { AccountSearchResult } from '@tcs/client-portal-api/types/AccountSearchResult';
import Table from '@tcs/client-portal-common/components/molecules/Table';
import BaseHeader from '@tcs/client-portal-common/components/molecules/Table/cells/headers/BaseHeader';
import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
import AmountCell from '@tcs/client-portal-common/components/molecules/Table/cells/AmountCell';
import { useStyles } from './style';

interface Props {
  accounts: AccountSearchResult[];
  onRowClick: (account: AccountSearchResult) => void;
  onColumnClick: (id: string) => void;
}

const AccountsTable = ({ accounts, onRowClick, onColumnClick }: Props) => {
  const classes = useStyles();

  const columns = [
    {
      accessor: 'name',
      header: () => <BaseHeader text="Name" />,
      cell: (info) => <BaseCell value={info.getValue()} />,
      size: 300,
    },
    {
      accessor: 'type',
      header: () => <BaseHeader text="Account Type" />,
      cell: (info) => <BaseCell value={info.getValue()} />,
      size: 300,
    },
    {
      accessor: 'id',
      header: () => <BaseHeader text="Account Number" />,
      cell: (info) => <BaseCell value={info.getValue()} />,
      size: 200,
    },
    {
      accessor: 'accountStatus',
      header: () => <BaseHeader text="Status" />,
      cell: (info) => <BaseCell value={info.getValue()} />,
      size: 200,
    },
    {
      accessor: 'availableCash',
      header: () => <BaseHeader text="Custodial Cash" align="right" />,
      cell: (info) => <AmountCell value={info.getValue()} />,
      size: 200,
    },
    {
      accessor: 'investmentValue',
      header: () => <BaseHeader text="Investment Value" align="right" />,
      cell: (info) => <AmountCell value={info.getValue()} />,
      size: 200,
    },
  ];

  return (
    <div>
      <Typography
        variant="h5"
        color="textPrimary"
        className={classes.title}
        data-test-id="representative-table-title">
        Accounts and Values
      </Typography>
      <Table
        data={accounts}
        columns={columns}
        onRowClick={onRowClick}
        onColumnClick={onColumnClick}
      />
    </div>
  );
};

export default AccountsTable;
